'use client'
import { useTranslations } from 'next-intl'

import { useFavoriteTotal } from '@web/app/[locale]/(web)/prod/[slug]/favorites-context'

export function Title() {
  const number = useFavoriteTotal()
  const t = useTranslations('prod.product_description_page')

  return (
    <div className="text-[18px] font-bold">
      {number > 0 ? t('favorite.added_copy', { number }) : undefined}
    </div>
  )
}
